module.exports = __webpack_public_path__ + "img/25x25_kirmizi.529f4772.gif";